var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F3F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3307 16.2513V19.7513C19.3307 22.668 18.1641 23.8346 15.2474 23.8346H11.7474C8.83073 23.8346 7.66406 22.668 7.66406 19.7513V16.2513C7.66406 13.3346 8.83073 12.168 11.7474 12.168H15.2474C18.1641 12.168 19.3307 13.3346 19.3307 16.2513Z",
    fill: "#292A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2469 7.16797H16.7469C14.2434 7.16797 13.0353 8.03362 12.7428 10.117C12.6654 10.6686 13.1269 11.1263 13.6838 11.1263H15.2469C18.7469 11.1263 20.3719 12.7513 20.3719 16.2513V17.8144C20.3719 18.3713 20.8296 18.8328 21.3811 18.7554C23.4646 18.4629 24.3302 17.2548 24.3302 14.7513V11.2513C24.3302 8.33464 23.1635 7.16797 20.2469 7.16797Z",
    fill: "#292A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.eaf4d0317a03e5db9a1ef4ae2eb41046.svg";
export { ForwardRef as ReactComponent };